export default "__VITE_ASSET__88a3e6f1__"